import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <div className="flex items-center space-x-2">
      <Globe size={18} className="text-zinc-400" />
      <button
        onClick={() => changeLanguage('en')}
        className={`text-sm ${i18n.language === 'en' ? 'text-violet-600 font-medium' : 'text-zinc-400 hover:text-white'} transition-colors`}
      >
        EN
      </button>
      <span className="text-zinc-700">|</span>
      <button
        onClick={() => changeLanguage('es')}
        className={`text-sm ${i18n.language === 'es' ? 'text-violet-600 font-medium' : 'text-zinc-400 hover:text-white'} transition-colors`}
      >
        ES
      </button>
    </div>
  );
};

export default LanguageSwitcher;
